// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".table th[data-v-763417ea], .table td[data-v-763417ea] {\n  vertical-align: middle;\n}", ""]);
// Exports
module.exports = exports;
